<template>
    <div>
        <vue-snotify></vue-snotify>
        <loading-indicator :sync="$store.getters.shouldLoadFullPage" :full-page="true"/>

        <transition name="component-fade" mode="out-in">
            <component :is="layout">
                <router-view></router-view>
            </component>
        </transition>
    </div>
</template>

<script>
import LoadingIndicator from "./components/Includes/LoadingIndicator";
export default {
    name: "App",
    components: {LoadingIndicator},
    data: () => ({
        defaultLayout: 'dashboard'
    }),
    watch: {
        getLanguage: function(value, oldVal) {
            this.$i18n.locale = value;
            this.$date.locale(value);
        }
    },
    mounted() {
        this.$i18n.locale = this.getLanguage;
        this.$date.locale(this.getLanguage);
    },
    computed: {
        layout() {
            return (this.$route.meta.layout || this.defaultLayout) + '-layout';
        },
        getLanguage(){
            return this.$store.state.language;
        }
    }

}
</script>
